/**
 * RegionBanner — INTENTIONALLY silent.
 * Geo is auto-detected via useGeo() hook and applied everywhere,
 * but we do NOT show a toggle UI. This component is kept as an
 * empty render so removing the mount elsewhere isn't required.
 */
export default function RegionBanner() {
  return null;
}
